"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEventStatusPropertyOption = exports.isEventStatusProperty = exports.eventStatusPropertyDefinition = void 0;
const eventStatusPropertyOptions = [
    'Confirmed',
    'Canceled',
    'Postponed',
    'Rescheduled',
    'Unconfirmed',
];
exports.eventStatusPropertyDefinition = {
    name: 'event-status',
    type: 'select',
    constraints: [
        {
            name: 'options',
            argument: eventStatusPropertyOptions,
        },
    ],
    multiple: false,
    default: 'Confirmed',
    view: {
        label: 'Status',
        hint: 'A <strong>confirmed</strong> event will take place on the date shown on the event<br>A <strong>canceled</strong> event will not take place at all<br>A <strong>postponed</strong> event still has the original date shown and the new event date is undecided<br>A <strong>rescheduled</strong> event has a new date decided and shown on the event<br>An <strong>unconfirmed</strong> event does not have a decided date. No date is shown on the event',
    },
};
const isEventStatusProperty = (prop) => {
    return prop.name === exports.eventStatusPropertyDefinition.name;
};
exports.isEventStatusProperty = isEventStatusProperty;
const isEventStatusPropertyOption = (option) => {
    return eventStatusPropertyOptions.includes(option);
};
exports.isEventStatusPropertyOption = isEventStatusPropertyOption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXZlbnQtc3RhdHVzLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvZXZlbnQtc3RhdHVzLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLE1BQU0sMEJBQTBCLEdBQUc7SUFDakMsV0FBVztJQUNYLFVBQVU7SUFDVixXQUFXO0lBQ1gsYUFBYTtJQUNiLGFBQWE7Q0FDTCxDQUFBO0FBRUcsUUFBQSw2QkFBNkIsR0FBRztJQUMzQyxJQUFJLEVBQUUsY0FBYztJQUNwQixJQUFJLEVBQUUsUUFBUTtJQUNkLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFNBQVM7WUFDZixRQUFRLEVBQUUsMEJBQTBCO1NBQ3JDO0tBQ0Y7SUFDRCxRQUFRLEVBQUUsS0FBSztJQUNmLE9BQU8sRUFBRSxXQUFXO0lBQ3BCLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxRQUFRO1FBQ2YsSUFBSSxFQUFFLDBiQUEwYjtLQUNqYztDQUM4QixDQUFBO0FBSTFCLE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxJQUFrQixFQUErQixFQUFFO0lBQ3ZGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxxQ0FBNkIsQ0FBQyxJQUFJLENBQUE7QUFDekQsQ0FBQyxDQUFBO0FBRlksUUFBQSxxQkFBcUIseUJBRWpDO0FBSU0sTUFBTSwyQkFBMkIsR0FBRyxDQUFDLE1BQWMsRUFBdUMsRUFBRTtJQUNqRyxPQUFRLDBCQUFnRCxDQUFDLFFBQVEsQ0FBQyxNQUFNLENBQUMsQ0FBQTtBQUMzRSxDQUFDLENBQUE7QUFGWSxRQUFBLDJCQUEyQiwrQkFFdkMifQ==